<template>
   <!-- Filter window. Keeps id="filterDataModal": tableMixin opens and closes it by this id -->
   <div id="filterDataModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
         <div class="modal-content bg-sa-modal-content">
            <div class="modal-header bg-sa-modal-header">
               <h4 class="modal-title"><i class="fa fa-filter me-2"></i>{{ title }}</h4>
               <button type="button" class="btn-close color-sa-btn-close" data-bs-dismiss="modal"></button>
            </div>

            <div class="modal-body">
               <AlertComponent
                  v-if="alert && alert.pageOrModal == 'modal'"
                  :alertstatus="alert.alertstatus"
                  :message="alert.alertMessage"
                  :type="alert.alertType"
               />

               <!-- Date range -->
               <DateRangeFilter
                  v-if="showDateRange"
                  v-model:preset="draft.datePreset"
                  v-model:year="draft.dateYear"
                  v-model:start-date="draft.startDate"
                  v-model:end-date="draft.endDate"
               />

               <!-- The page's own filters (Status, Tags, Module ...) -->
               <slot />

               <!-- View: All / By me / Deleted -->
               <SelectField
                  v-if="viewOptions.length"
                  v-model="draft.recordFilter"
                  col="mb-3"
                  input-id="recordFilter"
                  label="View"
                  icon="fa fa-eye"
                  :options="viewOptions"
                  :reduce="option => option.value"
                  :clearable="false"
               />

               <!-- Search By: applies straight away (belongs to the search box) -->
               <SelectField
                  v-if="searchByOptions.length"
                  v-model="searchByValue"
                  col="mb-3"
                  input-id="searchBy"
                  label="Search By"
                  icon="fa fa-search"
                  :options="searchByOptions"
                  :reduce="option => option.value"
                  :clearable="false"
                  @change="$emit('search-by-change')"
               />
            </div>

            <div class="modal-footer bg-sa-modal-footer">
               <button type="button" class="btn btn-outline-secondary" @click="$emit('clear')">
                  Clear filters
               </button>
               <button type="button" class="btn btn-default modal_close color-sa-modal_close" data-bs-dismiss="modal">
                  Close
               </button>
               <button type="button" class="btn btn-primary" @click="$emit('apply')">
                  <i class="fa fa-check me-1"></i> Apply filters
               </button>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
// Shared Filter window for table pages.
//   <FilterModal :draft="filterDraft" v-model:search-by="tableData.searchBy"
//                :view-options="viewOptions" :search-by-options="searchByOptions" :alert="defaultAlert"
//                @search-by-change="changePlaceholder()" @apply="applyFilters" @clear="clearFilters">
//      ...the page's own filter boxes (bind them to filterDraft.xxx)...
//   </FilterModal>
// draft = tableMixin's filterDraft: the window edits it, "Apply filters" copies it to the table.
import AlertComponent from "../ui/AlertComponent.vue";
import DateRangeFilter from "./DateRangeFilter.vue";
import SelectField from "./SelectField.vue";

export default {
   name: "FilterModal",
   components: { AlertComponent, DateRangeFilter, SelectField },
   props: {
      draft: { type: Object, required: true },             // filterDraft (edited directly)
      searchBy: { type: String, default: "" },             // tableData.searchBy (v-model:search-by)
      viewOptions: { type: Array, default: () => [] },     // empty = no View box
      searchByOptions: { type: Array, default: () => [] }, // empty = no Search By box
      alert: { type: Object, default: null },
      title: { type: String, default: "Filter records" },
      showDateRange: { type: Boolean, default: true },     // false for pages nobody filters by date
   },
   emits: ["update:searchBy", "search-by-change", "apply", "clear"],
   computed: {
      // The page's value is updated first, then search-by-change is sent
      searchByValue: {
         get() { return this.searchBy; },
         set(value) { this.$emit("update:searchBy", value); },
      },
   },
};
</script>